import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { menuItems, schoolInfo } from '../utils/mock';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src={schoolInfo.logo} 
              alt="AMTEE PUBLIC SCHOOL Logo" 
              className="h-14 w-14 object-contain"
            />
            <span className="font-extrabold text-xl text-yellow-500 tracking-tight">
              AMTEE PUBLIC SCHOOL
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-4">
            {menuItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-gray-700 hover:text-[#4A90E2] transition-colors duration-200 font-medium"
              >
                {item.name}
              </Link>
            ))}
            <Link to="/login">
              <Button className="bg-[#4A90E2] hover:bg-[#357ABD] text-white transition-colors duration-200">
                Parent Login
              </Button>
            </Link>
            <Link to="/teacher-login">
              <Button variant="outline" className="border-green-600 text-green-600 hover:bg-green-50 transition-colors duration-200">
                Teacher Login
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-[#4A90E2] transition-colors duration-200"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-4">
              {menuItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="text-gray-700 hover:text-[#4A90E2] transition-colors duration-200 font-medium"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Link to="/login" onClick={() => setIsOpen(false)}>
                <Button className="bg-[#4A90E2] hover:bg-[#357ABD] text-white w-full transition-colors duration-200">
                  Parent Login
                </Button>
              </Link>
              <Link to="/teacher-login" onClick={() => setIsOpen(false)}>
                <Button variant="outline" className="border-green-600 text-green-600 hover:bg-green-50 w-full transition-colors duration-200">
                  Teacher Login
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
